import { useState } from "react";
import { Dropdown, Button, InputNumber } from "antd";
import { DownOutlined } from "@ant-design/icons";

export default function RoomsGuestsDropdown() {
  const [rooms, setRooms] = useState(1);
  const [adults, setAdults] = useState(2);
  const [children, setChildren] = useState(0);
  const [open, setOpen] = useState(false); // control dropdown

  const menuContent = (
    <div className="bg-white rounded-md shadow-lg p-6 w-full">
      {/* Room */}
      <div className="flex justify-between items-center mb-4">
        <span className="font-semibold">Room</span>
        <InputNumber
          min={1}
          value={rooms}
          onChange={setRooms}
          className="w-16"
        />
      </div>

      {/* Adults */}
      <div className="flex justify-between items-center mb-4">
        <span className="font-semibold">Adults</span>
        <InputNumber
          min={1}
          value={adults}
          onChange={setAdults}
          className="w-16"
        />
      </div>

      {/* Children */}
      <div className="flex justify-between items-center">
        <div>
          <span className="font-semibold">Children</span>
          <p className="text-xs text-gray-500">0 - 17 Years Old</p>
        </div>
        <InputNumber
          min={0}
          value={children}
          onChange={setChildren}
          className="w-16"
        />
      </div>

      {/* Note */}
      <p className="text-xs text-gray-500 mt-3">
        Please provide right number of children along with their right age for
        best options and prices.
      </p>

      {/* Apply Button */}
      <div className="flex justify-end mt-5">
        <Button
          type="primary"
          className="rounded-full px-6"
          onClick={() => setOpen(false)} // close popup
        >
          APPLY
        </Button>
      </div>
    </div>
  );

  return (
    <>
      <div className="cursor-pointer rounded-md px-4 w-48 flex">
        <span className="">{'Rooms & Guests'}</span>
        <DownOutlined className="ml-1" />
      </div>
      <Dropdown
        dropdownRender={() => menuContent}
        trigger={["click"]}
        placement="bottomLeft"
        open={open}
        onOpenChange={setOpen} // sync with state
      >
        <div className="cursor-pointer rounded-md px-4 py-3 flex items-center justify-between">
          <span className="font-medium text-xl">
            <span className="font-bold">{rooms}</span>{" "}
            <span className="text-sm">Rooms </span>
            <span className="font-bold">{adults}</span>{" "}
            <span className="text-sm">Adults</span>
          </span>
          <DownOutlined className="text-gray-500 ml-2" />
        </div>
      </Dropdown>
    </>
  );
}
